

import {
  Component,
  OnInit,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import { Subject } from "rxjs";
import { Impresa } from "src/app/models/impresa.model";
import { Listino } from "src/app/models/listino.model";
import { ListinoNazionale } from "src/app/models/listinoNazionale.model";
import { ImpreseService } from "src/app/services/imprese.service";
import { ListiniService } from "src/app/services/listini.service";
import { StiliService } from "src/app/services/stili.service";
import { UtilService } from "src/app/services/util.service";


@Component({
  templateUrl: "./dialog-storico-nazionale.component.html",
  styleUrls: ["../listino.component.css"],
})
export class StoricoNazionaleComponent implements OnInit {
  protected _onDestroy              = new Subject<void>();
  
  protected isLoadingStoricoNazionale:Boolean = false;
  protected storicoNazionale:ListinoNazionale[] = [];
  protected currentListino:ListinoNazionale;
  constructor(
    private logger: NGXLogger,
    public dialogRef: DynamicDialogRef,
    public stiliService:StiliService,
    public config: DynamicDialogConfig,
    private impreseService: ImpreseService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private _formBuilder: FormBuilder,
    private listiniService:ListiniService,
    private utilService:UtilService,

  ) {
   // this.storicoNazionale = this.config.data.listino;
  
  }

  ngOnInit(): void {
      this.loadStoricoNazionale();
  
  }

  
  loadStoricoNazionale(){
    this.listiniService.getStoricoNazionale().subscribe( {
      next: (res) => {
        this.storicoNazionale = res;
        this.storicoNazionale.forEach(listino => {
          if(!listino.eliminato){
            this.currentListino = listino;
          }
        });
      },
      error: (e) => {
        this.logger.info(e);
        this.messageService.add({life: 10000,severity:'error', summary:'Errore', detail:'Errore in fase di caricamento dello storico del listino nazionale'});
    },
      complete: () => {
      }
  });
  }

  getCampiModificati(listino:ListinoNazionale):string{
    let modifiche:string = "";
    modifiche+="SCL1:" + listino.scl1 + "<br>";
    modifiche+="SCL2:" +listino.scl2 + "<br>";
    modifiche+="SCL3:" +listino.scl3 + "<br>";
    modifiche+="SCL4:" +listino.scl4 + "<br>";
    modifiche+="SCL5:" +listino.scl5 + "<br>";
    /* if(listino.scl1!==this.currentListino.scl1){
      this.logger.info(listino.scl1 + " Vs " + this.currentListino.scl1)
      modifiche+="SCL1 (" + listino.scl1 + ") ";
    }
    if(listino.scl2!==this.currentListino.scl2){
      modifiche+="SCL2 (" +listino.scl2 + ") ";
    }
    if(listino.scl3!==this.currentListino.scl3){
      modifiche+="SCL3 (" +listino.scl3 + ") ";
    }
    if(listino.scl4!==this.currentListino.scl4){
      modifiche+="SCL4 (" +listino.scl4 + ") ";
    }
    if(listino.scl5!==this.currentListino.scl5){
      modifiche+="SCL5 (" +listino.scl5 + ") ";
    } */

    return modifiche;
  }
  formatDate(dateString) {
    // Rimuove la parte [UTC] dalla stringa e crea un oggetto Date
    const date = new Date(dateString.replace('[UTC]', ''));

    // Estrai giorno, mese e anno
    const day = String(date.getUTCDate()).padStart(2, '0');
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // I mesi partono da 0
    const year = date.getUTCFullYear();

    // Formatta in dd/mm/yyyy
    return `${day}/${month}/${year}`;
}

  formattaStoricio(storico:ListinoNazionale):string{
    if(storico.eliminato){
      return "MODIFICATO"
    }else{
      return "ATTIVO";
    }
  }

  conferma(conferma: boolean) {
    if (!conferma) {
      this.dialogRef.close({ success: false });
    } else {
      
          this.dialogRef.close({ success: true });
       
    
    }
  }
}
